import React from "react";
import { Routes,Route} from "react-router-dom";
import Person from "./PersonalDetails";
import Home from "./Home";
import Payment from "./Payment";
import Actions from "./actions";
import EditPerson from "./CustomerEdit";
import Newloan from "./Newloan";
import Ledger from "./Ledger";
import Loandetails from "./Loandetails";
import Dailyloanlist from "./DailyLoanList";
import Dailycollection from "./DailyCollection";
import Balancereport from "./BalanceReport";
import Login from "./Login";
import Expenses from "./Expenses.js";
import Editreceipt from "./EditReceipt";
import Changes from "./Changes";
import Editloan from "./EditLoan";
import Interestreport from "./interestReport";
import Expensesreport from "./ExpensesReport";
import Finereport from "./FineReport";
import Deleteloan from "./DeleteLoan";
import Deleteexpense from "./DeleteExpense";
import Customerloanlodger from "./CustomerLoanLedger";
import Ledgerview from "./Ledgerview";
import Dayclosing from "./DayClosing";
import Deposits from "./Deposits";
import Defaulters from "./Defaulters";
import Userloan from "./UserLoan.js";
import Accounts from "./Accounts.js";
import User from "./User.js";
import Createuser from "./CreateUser.js";
import Userdayclosing from "./UserDayClosing.js";
import Modifyuser from "./ModifyUser.js";
import Deleteuserloan from "./DeleteUserLoan.js";
import Userloantopup from "./UserLoanTopup.js";
import Deletedeposit from "./DeleteDeposit.js";
import Editexpenseshead from "./EditExpenseHead.js";
import Cashinhand from "./CashinHand.js";
import AddExpensehead from "./AddExpenseHead.js";
import Weeklyloan from "./Weekly/Weeklyloan.js";
import Expectingdue from "./ExpectingDue.js";
import Welcomehome from "./WelcomeHome.js";
import Circle from "./Circle.js";



function App(){
    return (
        <div>
            
            <Routes>
            <Route exact path="/" element ={<Welcomehome/>}></Route>
                <Route exact path="/login" element = {<Login/>} />
                <Route exact path="/home" element = {<Home/>} />
                <Route exact path="/person" element ={<Person />}/>
                <Route exact path = "/newloan" element = {<Newloan/>}/>
                <Route exact path = "/payment" element = {<Payment/>}/>
                <Route exact path = "/actions" element = {<Actions/>}/>
                <Route exact path="/editperson" element = {<EditPerson/>}/>
                <Route exact path="/ledger" element ={<Ledger/>}></Route>
                <Route exact path="/loandetails" element ={<Loandetails/>}></Route>
                <Route exact path="/dailyloanlist" element ={<Dailyloanlist/>}></Route>
                <Route exact path="/dailycollection" element ={<Dailycollection/>}></Route>
                <Route exact path="/balancereport" element ={<Balancereport/>}></Route>
                <Route exact path="/expenses" element ={<Expenses/>}></Route>
                <Route exact path="/editreceipt" element ={<Editreceipt/>}></Route>
                <Route exact path="/changes" element ={<Changes/>}></Route>
                <Route exact path="/editloan" element ={<Editloan/>}></Route>
                <Route exact path="/deleteloan" element ={<Deleteloan/>}></Route>
                <Route exact path="/interestreport" element ={<Interestreport/>}></Route>
                <Route exact path="/expensesreport" element ={<Expensesreport/>}></Route>
                <Route exact path="/finereport" element ={<Finereport/>}></Route>
                <Route exact path="/deleteexpense" element ={<Deleteexpense/>}></Route>
                <Route exact path="/customerledger" element ={<Customerloanlodger/>}></Route>
                <Route exact path="/ledgerview" element ={<Ledgerview/>}></Route>
                <Route exact path="/dayclosing" element ={<Dayclosing/>}></Route>
                <Route exact path="/deposits" element ={<Deposits/>}></Route>
                <Route exact path="/defaulters" element ={<Defaulters/>}></Route>
                <Route exact path="/user" element ={<User/>}></Route>
                <Route exact path="/accounts" element ={<Accounts/>}></Route>
                <Route exact path="/createuser" element ={<Createuser/>}></Route>
                <Route exact path="/userloan" element ={<Userloan/>}></Route>
                <Route exact path="/userdayclosing" element ={<Userdayclosing/>}></Route>
                <Route exact path="/modifyuser" element ={<Modifyuser/>}></Route>
                <Route exact path="/deleteuserloan" element ={<Deleteuserloan/>}></Route>
                <Route exact path="/userloantopup" element ={<Userloantopup/>}></Route>
                <Route exact path="/deletedeposit" element ={<Deletedeposit/>}></Route>
                <Route exact path="/editexpensehead" element ={<Editexpenseshead/>}></Route>
                <Route exact path="/cashinhand" element ={<Cashinhand/>}></Route>
                <Route exact path="/addexpensehead" element ={<AddExpensehead/>}></Route>
                <Route exact path="/expectingdue" element ={<Expectingdue/>}></Route>
                

            </Routes>
            
         </div>
    )

    
}
export default App;